module.exports = __webpack_public_path__ + "adc48bdd6a9bf5717ec9f9ec5865f622.svg";